/**
 * Приветственная инструкция.
 *
 * Правила раунда объясняет отдельное окно перед первой партией; здесь речь о
 * проекте целиком — что тут есть кроме угадывания и как этим пользоваться.
 * Новичок иначе видит каталог, шапку с тремя иконками и не понимает, зачем
 * они, а половину возможностей не находит вовсе.
 *
 * Показывается один раз после регистрации; признак хранится у пользователя,
 * а не в браузере, поэтому со второго устройства окно не повторится. Открыть
 * заново можно кнопкой в шапке — люди возвращаются к справке.
 */
import { useTranslation } from "react-i18next";

import { Dialog } from "./Dialog";

/** Разделы инструкции. Ключи ведут в словарь: текст переводится целиком. */
const SECTIONS = ["game", "quests", "round", "room", "create", "feedback"] as const;

export function WelcomeGuide({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <Dialog title={t("guide.title")} onClose={onClose}>
      <p className="text-sm text-ink-300">{t("guide.lead")}</p>

      <ol className="mt-4 space-y-3">
        {SECTIONS.map((key, index) => (
          <li key={key} className="flex gap-3">
            <span
              className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full
                         border border-amber-400/40 text-xs text-amber-300"
              aria-hidden
            >
              {index + 1}
            </span>
            <div className="min-w-0">
              <h3 className="font-sans text-base text-ink-50">{t(`guide.${key}.title`)}</h3>
              <p className="mt-0.5 text-sm leading-relaxed text-ink-300">
                {t(`guide.${key}.text`)}
              </p>
            </div>
          </li>
        ))}
      </ol>

      <button type="button" className="btn-primary mt-5 w-full" onClick={onClose}>
        {t("guide.start")}
      </button>
    </Dialog>
  );
}
